/* eslint-env browser */
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import Url from 'url';

import TalentTraits from 'shared/talentTraits';
import { MAX_LEVEL } from 'shared/constants';

import TalentTree from 'frontend/components/Simbot/TalentTree';

import config from 'frontend/config';

class TalentTreeRender extends React.Component {
  static propTypes = {
    params: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  static childContextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    rebass: PropTypes.object,
  };

  // eslint-disable-next-line class-methods-use-this
  getChildContext() {
    return {
      rebass: {
        ...config,
      },
    };
  }

  render() {
    const parsed = TalentTraits.parse(decodeURIComponent(this.props.params.talentString));

    if (!parsed) {
      return null;
    }

    const url = Url.parse(window.location.href, true);
    const width = parseInt(url.query.width, 10) || 1100;
    const level = parseInt(url.query.level, 10) || MAX_LEVEL;
    const mini = Boolean(url.query.mini);
    const hideExport = Boolean(url.query.hideexport) || Boolean(url.query.hideExport);
    const hideHeader = Boolean(url.query.hideheader) || Boolean(url.query.hideHeader);
    let bgColor = 'transparent';
    if (url.query.bgcolor) {
      bgColor = `#${url.query.bgcolor}`;
    }

    return (
      <div
        style={{
          fontFamily: config.fontFamily,
          fontWeight: config.fontWeight,
          letterSpacing: config.letterSpacing,
          color: config.colors.white,
          backgroundColor: bgColor,

          height: '100%',
          minHeight: '100%',

          width: '100%',
          minWidth: width,
        }}
      >
        <TalentTree
          specId={parsed.specId}
          level={level}
          width={width}
          talents={parsed.rawInput}
          mini={mini}
          hideExport={hideExport}
          hideHeader={hideHeader}
          readOnly
          hideFooter
        />
      </div>
    );
  }
}

export default withRouter(TalentTreeRender);
